// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { BaseScheduleModalLayoutCoachFragmentDoc } from './BaseScheduleModalLayout.generated';
export type BaseScheduleSubmissionModalLayoutCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  newExperience?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
  };
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
  } | null;
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
};

export const BaseScheduleSubmissionModalLayoutCoachFragmentDoc = gql`
  fragment BaseScheduleSubmissionModalLayout_Coach on Coach {
    id
    ...BaseScheduleModalLayout_Coach
  }
  ${BaseScheduleModalLayoutCoachFragmentDoc}
`;
